import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { DropPage } from './drop/DropPage.tsx';
import { App } from './app/App.tsx';

const root = document.getElementById('root');
if (!root) throw new Error('missing #root');

// Two surfaces, one bundle. `/app` is mine; everything else is the drop page.
const isApp = location.pathname === '/app' || location.pathname.startsWith('/app/');

createRoot(root).render(<StrictMode>{isApp ? <App /> : <DropPage />}</StrictMode>);
